import { Component } from '@angular/core';

@Component({
  selector: 'app-wifi-landing-page',
  templateUrl: './wifi-landing-page.component.html',
  styleUrls: ['./wifi-landing-page.component.scss']
})
export class WifiLandingPageComponent {

}
